<ng-container *ngIf="!linkAddedToParent; else content">
  <a
    *ngIf="item?.link?.hasInternalLink()"
    [appSubmenuHover]="item"
    [class.disabled]="disabled ? true : null"
    [class]="classname"
    [fragment]="item.hrefAnchor || null"
    [queryParams]="item.link.getQueryParams()"
    [rel]="item.link.getRel()"
    [routerLinkActiveOptions]="{ exact: false }"
    [routerLink]="item.link.getLink()"
    [attr.download]="item.link.getDownload()"
    (click)="item.link.onClickLink($event)"
    [target]="item.link.getTarget()"
    routerLinkActive="active-link"
    [attr.tabindex]="tabindexAddedToParent ? '-1' : item.tabindex"
    [attr.aria-label]="item.link.linkDescription || null"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>

  <a
    *ngIf="item?.link?.hasExternalLink()"
    [appSubmenuHover]="item"
    [class.disabled]="!!disabled"
    [class]="classname"
    [href]="item.link.getLink()"
    [attr.download]="item.link.getDownload()"
    (click)="item.link.onClickLink($event)"
    [rel]="item.link.getRel()"
    [target]="item.link.getTarget()"
    [attr.tabindex]="tabindexAddedToParent ? '-1' : item.tabindex"
    [attr.aria-label]="item.link.linkDescription || null"

  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<div
  #submenuPanel
  *ngIf="hesSubmenu"
  [@submenuContainer]="state"
  class="submenu hide"
  [attr.aria-label]="item.link.linkDescription || null"
>
  <div class="menu-overlay"></div>
  <ng-template #submenuContainerRef></ng-template>
</div>

<ng-container *ngIf="!item?.link?.hasLink()">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
